import { useMemo, useState, type ReactNode } from 'react';

import { AppBreadcrumbCtx } from '@/hooks/app-breadcrumb-store';

export function AppBreadcrumbProvider({ children }: { readonly children: ReactNode }) {
  const [templateLabel, setTemplateLabel] = useState<string | null>(null);
  const value = useMemo(
    () => ({ templateLabel, setTemplateLabel }),
    [templateLabel],
  );

  return <AppBreadcrumbCtx value={value}>{children}</AppBreadcrumbCtx>;
}
